module.exports = __webpack_public_path__ + "img/2.2005947f.png";